import { SwipeableDrawer } from "@material-ui/core";
import React from "react";
import DescriptionIcon from "@material-ui/icons/Description";
import { css, cx } from "emotion";
import CloseIcon from "@material-ui/icons/Close";
import ReconciliationStore from "../../../Store/ReconciliationStore";
import { Skeleton } from "@material-ui/lab";
import moment from "moment-timezone";

const drawerStyle = css`
  min-width: 300px !important;
  padding: 16px 12px;

  @media (max-width: 576px) {
    width: 100vw;
  }
`;

const DrawerHistory = (props) => {
  var idLocale = require("moment/locale/id");
  moment.locale("id", idLocale);

  const { anchor, onClickHistory } = props;
  const [open, setOpen] = React.useState(false);
  const [reconciliationState, reconciliationActions] = ReconciliationStore();

  const toggleDrawer = (open) => (event) => {
    if (
      event &&
      event.type === "keydown" &&
      (event.key === "Tab" || event.key === "Shift")
    ) {
      return;
    }

    setOpen(open);
  };

  const getReconciliationList = (refresh) => {
    const params = {
      num: 10,
      cursor: refresh ? "" : reconciliationState?.header["x-cursor"] || "",
    };
    reconciliationActions.getReconciliationList(params, refresh);
  };

  const handleClickHistory = (id) => {
    setOpen(false);
    setTimeout(onClickHistory(id), 500)
  };

  React.useEffect(() => {
    if (open === true) {
      getReconciliationList(true);
    }
  }, [open]);

  return (
    <React.Fragment>
      <button
        type="button"
        className="btn bg-white text-primary rounded-8px border-gray-300 font-12 font-bold"
        onClick={toggleDrawer(true)}
      >
        <DescriptionIcon className="mr-2" />
        History
      </button>
      <SwipeableDrawer
        anchor={anchor}
        open={open}
        onOpen={toggleDrawer(true)}
        onClose={toggleDrawer(false)}
      >
        <div className={drawerStyle}>
          <div className="w-100 d-flex justify-content-between align-items-center">
            <h4 className="font-16 font-bold text-primary mb-0">History</h4>
            <button
              type="button"
              className="btn p-0 d-block d-sm-none"
              onClick={toggleDrawer(false)}
            >
              <CloseIcon />
            </button>
          </div>
          <hr
            className={css`
              display: block;
              border: solid 1px #eeeeee;
            `}
          />
          <div
            className={css`
              max-height: calc(100vh - 41px);
              overflow-y: scroll;
            `}
          >
            {reconciliationState?.reconciliations?.length > 0 &&
              reconciliationState?.reconciliations?.map((val, key) => {
                return (
                  <div
                    key={key}
                    className={cx(
                      css`
                        padding: 16px 12px !important;
                        border: 1px solid #eeeeee;
                        border-radius: 8px;

                        :hover {
                          background-color: #eeeeee;
                        }
                      `,
                      "card card-body mb-2 cursor-pointer"
                    )}
                    onClick={() => handleClickHistory(val.id)}
                  >
                    <p className="font-bold font-12 text-primary mb-2">
                      {moment(val.create_time).format("LL")}
                    </p>
                    <small className="d-block font-10 text-muted">File</small>
                    <p className="font-bold font-10 text-primary mb-2">
                      {val.file_url.split("/").pop()}
                    </p>
                    <small className="d-block font-10 text-muted">Result</small>
                    {val.reconciliation_failed > 0 && (
                      <p className="font-bold font-10 text-danger mb-0">
                        {val.reconciliation_failed} task tidak sama
                      </p>
                    )}

                    {val.reconciliation_failed === 0 && (
                      <p className="font-bold font-10 text-success mb-0">
                        Match
                      </p>
                    )}
                  </div>
                );
              })}
            {reconciliationState?.isLoading &&
              Array.from(new Array(5)).map((v, key) => {
                return (
                  <div className="p-0 mb-2" key={key}>
                    <Skeleton variant="rect" width="100%" height={116} />
                  </div>
                );
              })}
            {!reconciliationState.isLoading && !reconciliationState?.lastPage &&
              reconciliationState?.reconciliations?.length > 0 && (
                <div className="text-center">
                  <button
                    type="button"
                    className="btn btn-sm btn-white"
                    onClick={() => getReconciliationList(false)}
                  >
                    Load more
                  </button>
                </div>
              )}
          </div>
        </div>
      </SwipeableDrawer>
    </React.Fragment>
  );
};

export default DrawerHistory;
